// 시각·숫자 표기. 형식이 한 곳에 있어야 레인마다·서비스마다 툴팁과 축이 같은 모양으로 남는다.

const pad = (n) => String(n).padStart(2, '0')

// 툴팁용 전체 시각. 24시간제로 고정한다 — ko-KR 기본은 「오후 03:12」라 표를 세로로 훑을 때
// 오전·오후를 매번 읽어야 한다.
const FULL_OPTS = {
  year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
}
const FULL = new Intl.DateTimeFormat('ko-KR', FULL_OPTS)

// 시간대마다 형식기를 한 번만 만든다 — Intl.DateTimeFormat 생성은 비싸고, 축 눈금은 그릴 때마다 부른다.
const fullIn = new Map()
const partsIn = new Map()
function fullFormatter(timeZone) {
  if (!timeZone) return FULL
  if (!fullIn.has(timeZone)) fullIn.set(timeZone, new Intl.DateTimeFormat('ko-KR', { ...FULL_OPTS, timeZone }))
  return fullIn.get(timeZone)
}

// formatTime(t, timeZone?) — timeZone(IANA 이름, 예 'Asia/Seoul')을 주면 그 시간대로 적는다.
// 안 주면 지금처럼 브라우저 시간대다(안 깨는 추가).
export const formatTime = (t, timeZone) => fullFormatter(timeZone).format(new Date(t))

// 한 시각을 그 시간대의 월·일·시·분·초 숫자로. 시간대가 없으면 브라우저 시간대(Date 의 get*).
function clockOf(t, timeZone) {
  const d = new Date(t)
  if (!timeZone) return { mo: d.getMonth() + 1, da: d.getDate(), h: d.getHours(), mi: d.getMinutes(), s: d.getSeconds() }
  if (!partsIn.has(timeZone)) {
    partsIn.set(timeZone, new Intl.DateTimeFormat('en-US', {
      timeZone, month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23',
    }))
  }
  const p = {}
  for (const { type, value } of partsIn.get(timeZone).formatToParts(d)) p[type] = Number(value)
  return { mo: p.month, da: p.day, h: p.hour % 24, mi: p.minute, s: p.second }
}

const DAY = 86_400_000

// axisTimeValues 는 uPlot 축의 values 함수다(시각이 ms 인 축).
//
// 눈금 간격이 하루 이상이면 날짜(MM.DD)만, 그보다 짧으면 시각(HH:mm)을 적되 **날짜가
// 바뀌는 눈금과 첫 눈금에는 날짜를 붙인다.** 시각만 적으면 자정을 넘는 구간에서 「03:00」이
// 어느 날인지 알 길이 없다.
export function axisTimeValues(_u, splits, _axisIdx, _space, incr) {
  return axisLabels(splits, incr, undefined)
}

// axisTimeValuesIn(timeZone) — 같은 규칙을 정해진 시간대로 적는 values 함수를 돌려준다.
// TimeChart 의 timeZone 이 이것을 쓴다. 현장 PC 시계가 UTC 여도 KST 로 읽어야 하는 화면용이다.
export function axisTimeValuesIn(timeZone) {
  return (_u, splits, _axisIdx, _space, incr) => axisLabels(splits, incr, timeZone)
}

function axisLabels(splits, incr, timeZone) {
  let prevDay = null
  return splits.map((t) => {
    if (t == null) return null
    const c = clockOf(t, timeZone)
    const day = `${pad(c.mo)}.${pad(c.da)}`
    if (incr >= DAY) return day
    const hm = incr < 60_000
      ? `${pad(c.h)}:${pad(c.mi)}:${pad(c.s)}`
      : `${pad(c.h)}:${pad(c.mi)}`
    const withDay = day !== prevDay
    prevDay = day
    return withDay ? `${day} ${hm}` : hm
  })
}

// formatPct 는 0~100 값을 읽기 좋게 줄인다. 10 이상은 정수, 그 아래는 한 자리.
export const formatPct = (v) => (v == null ? '—' : `${v.toFixed(v >= 10 ? 0 : 1)}%`)
